import { gql } from "@apollo/client";

const GetUnreadChatCountsQuery = gql`
  query getUnreadChatCounts($agentId: ID!) {
    getUnreadChatCounts(agentId: $agentId) {
      facebook
      instagram
      whatsapp
      comments
      chatbot
      facebookIds
      instagramIds
      whatsappIds
      commentsIds
      chatbotConversationIds
    }
  }
`;

export default GetUnreadChatCountsQuery;
